__turbopack_context__.v({
  "bottomHalf": "SingleEventCard-module-scss-module__sqVxRW__bottomHalf",
  "eventFacts": "SingleEventCard-module-scss-module__sqVxRW__eventFacts",
  "favoriteButton": "SingleEventCard-module-scss-module__sqVxRW__favoriteButton",
  "image": "SingleEventCard-module-scss-module__sqVxRW__image",
  "imageLink": "SingleEventCard-module-scss-module__sqVxRW__imageLink",
  "imageWrapper": "SingleEventCard-module-scss-module__sqVxRW__imageWrapper",
  "primaryBottom": "SingleEventCard-module-scss-module__sqVxRW__primaryBottom",
  "primaryImage": "SingleEventCard-module-scss-module__sqVxRW__primaryImage",
  "secondaryBottom": "SingleEventCard-module-scss-module__sqVxRW__secondaryBottom",
  "secondaryImage": "SingleEventCard-module-scss-module__sqVxRW__secondaryImage",
  "singleEventCard": "SingleEventCard-module-scss-module__sqVxRW__singleEventCard",
  "tags": "SingleEventCard-module-scss-module__sqVxRW__tags",
  "title": "SingleEventCard-module-scss-module__sqVxRW__title",
});
